import React, { useState } from "react";
import { Client } from "../../interfaces/client";
import { uploadGeneralClientDocument } from "../../services/clientService";

interface UploadGeneralClientDocProps {
  client: Client;
  onClose: (message?: string) => void;
}

const UploadGeneralClientDoc: React.FC<UploadGeneralClientDocProps> = ({
  client,
  onClose,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const handleUploadResponse = async () => {
    if (!file) return;

    try {
      setLoadingSpinner(true);
      await uploadGeneralClientDocument(client, file);
      onClose();
    } catch (error) {
      console.error("Error handling file upload:", error);
      setErrorMessage("Error uploading additional form.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  const handleGrabForm = async () => {
    try {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*,.pdf";
      fileInput.click();
      fileInput.onchange = async (event: any) => {
        const file = event.target.files[0];
        if (!file) return;
        setFile(file);
      };
    } catch (error) {
      console.error("Error handling file upload:", error);
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Upload Client Document</h2>
          <div>
            Please name the file as <b>client/form name/MMYY</b> to avoid
            overwriting a file with the same name.
          </div>
        </div>
        <br></br>
        <div className="dialog-container">
          <div className="action-buttons">
            <button className="smbtn btn-grey" onClick={() => handleGrabForm()}>
              Upload Document
            </button>
            {file && (
              <a
                href={URL.createObjectURL(file)}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Document
                <i className="btn-icon bi bi-box-arrow-up-right"></i>
              </a>
            )}
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
        <div className="filter-actions">
          <button
            className={`smbtn btn-green ${!file ? "disabled" : ""}`}
            onClick={handleUploadResponse}
            disabled={!file}
          >
            Save to Client
          </button>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default UploadGeneralClientDoc;
